import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { ActionPlanFilterStore } from '@/contexts/action-plans/ActionPlans.interfaces'

export const useActionsListFiltersStore = defineStore(
  'actions-list-filters',
  () => {
    const actionsListFilters = ref<ActionPlanFilterStore[]>([])

    const updateActionsListFilters = (newFilters: ActionPlanFilterStore) => {
      const filterIndex = actionsListFilters.value.findIndex(
        (storeFilter) =>
          storeFilter.actionPlanId === newFilters.actionPlanId && storeFilter.customerId === newFilters.customerId
      )

      if (filterIndex >= 0) {
        actionsListFilters.value.splice(filterIndex, 1, newFilters)
      } else {
        actionsListFilters.value.push(newFilters)
      }
    }

    const getActionsListFilterById = (actionPlanId: string, customerId: number): ActionPlanFilterStore | undefined => {
      return actionsListFilters.value.find(
        (storedFilter) => storedFilter.actionPlanId === actionPlanId && storedFilter.customerId === customerId
      )
    }

    const removeActionsListFilterById = (actionPlanId: string, customerId: number) => {
      actionsListFilters.value = actionsListFilters.value.filter(
        (storedFilter) => !(storedFilter.actionPlanId === actionPlanId && storedFilter.customerId === customerId)
      )
    }

    function $reset() {
      actionsListFilters.value = []
    }

    return {
      actionsListFilters,
      updateActionsListFilters,
      getActionsListFilterById,
      removeActionsListFilterById,
      $reset,
    }
  },
  { persist: true }
)
